import React from 'react';
import * as dateFns from 'date-fns';
import { Link } from 'react-router-dom';

import { TEAMS_NAMES } from '../../../../config/constants';
import Badge from '../../Badge/Badge';
import { selectedPracticeRoute } from '../../../../helpers';
import { GameBadgePropsType } from './types';
import { useUserState } from '../../../../store/hooks';
import { useRouter } from '../../../../helpers/customHooks';

import './styles.scss';

const GameBadge = ({ game, tooltipData, margin, clas, height, vertical, noHover }: GameBadgePropsType) => {
  
  const user = useUserState();
  const { pathname } = useRouter();
  const win = !game.isFuture && game.score && Object.keys(game.score).length !== 0 ?
    (game.score.visitorTeamScore.pointTotal > game.score.homeTeamScore.pointTotal ? 1 :
        (game.score.visitorTeamScore.pointTotal < game.score.homeTeamScore.pointTotal ? 2 : 0)
    ) : 0;
  const homeTeamName = TEAMS_NAMES.reduce(((result, team) => (team.short === game.homeTeamAbbr ? team : result)), {
    name: 'default',
    short: 'CC'
  });
  const visitorTeamName = TEAMS_NAMES.reduce(((result, team) => (team.short === game.visitorTeamAbbr ? team : result)), {
    name: 'default',
    short: 'CC'
  });
  const left = game.homeTeamId === '194' || game.homeTeamId === '19410' ? (
    <div className={'game-left'}>
      <div className={'future-game-badge-cell'}><img alt='gameimg' src={'/assets/images/logos/' +
      homeTeamName.short + '.svg'} height="15" width="15" /></div>
      <div className={'future-game-badge-cell'} style={{ textAlign: 'right' }}>{game.homeTeamAbbr} Game</div>
    </div>
  ) : (!game.isFuture && game.score ?
      <div>
        <div className={'game-badge-cell' + (win === 1 ? ' label-bold' : '')}>{game.visitorTeamAbbr}</div>
        <div className={'game-badge-cell'}><img alt='gameimg' src={'/assets/images/logos/' +
        visitorTeamName.short + '.svg'} height="15" width="15" /></div>
        <div
          className={'game-badge-cell' + (win === 1 ? ' label-bold' : '')}>{Object.keys(game.score).length !== 0 ? game.score.visitorTeamScore.pointTotal : '-'}</div>
        <div className={'oo-ee'}>@</div>
        <div
          className={'game-badge-cell' + (win === 2 ? ' label-bold' : '')}>{Object.keys(game.score).length !== 0 ? game.score.homeTeamScore.pointTotal : '-'}</div>
        <div className={'game-badge-cell'}><img alt='gameimg' src={'/assets/images/logos/' +
        homeTeamName.short + '.svg'} height="15" width="15" /></div>
        <div className={'game-badge-cell ' + (win === 2 ? ' label-bold' : '')}>{game.homeTeamAbbr}</div>
      </div> :
      <div className={'game-left'}>
        <div className={'future-game-badge-cell'}> {game.visitorTeamAbbr} </div>
        <div className={'future-game-badge-cell'}><img alt='gameimg' src={'/assets/images/logos/' +
        visitorTeamName.short + '.svg'} height="15" width="15" /></div>
        <div className={'oo-ee'}>@</div>
        <div className={'future-game-badge-cell'}><img alt='gameimg' src={'/assets/images/logos/' +
        homeTeamName.short + '.svg'} height="15" width="15" /></div>
        <div className={'future-game-badge-cell'} style={{ textAlign: 'right' }}>{game.homeTeamAbbr}</div>
      </div>
  );
  const right = (!game.isFuture && game.score ? null :
    <div className={'right'}>{dateFns.format(new Date(game.startTime), 'hh:mm a')} </div>);
  /*
   if (user.teamShort===game.team.A ) {
   left = (<div className={'left'}>
   {'VS '}
   <img alt='gameimg' src={'/assets/images/logos/'+game.team.B+'.svg'} height='15' width='15' />
   {game.team.B}
   </div>);
   right = (<div className={'right'}>
   {game.score.A>game.score.B?
   <label style={{color:'green'}}>{'W '}</label>:
   game.score.A<game.score.B?<label style={{color:'red'}}>{'L '}</label>:<label>T</label>}
   <label style={{fontWeight:'bold'}}>{game.score.A}</label>-<label>{game.score.B}</label></div>);
   }
   if (user.teamShort===game.team.B ) {
   left = (<div className={'left'}>
   {'VS '}
   <img alt='gameimg' src={'/assets/images/logos/'+game.team.A+'.svg'} height="15" width="15" />
   {game.team.A}
   </div>);
   right = (<div className={'right'}>
   {game.score.A>game.score.B?
   <label style={{color:'green'}}>{'W '}</label>:
   game.score.A<game.score.B?<label style={{color:'red'}}>{'L '}</label>:<label>T</label>}
   <label>{game.score.A}</label>-<label style={{fontWeight:'bold'}}>{game.score.B}</label></div>);
   }
   */
  return (
    <Link to={{ pathname: selectedPracticeRoute(pathname, game, user), state: { toReturn: pathname } }}>
      <div
        className={`bd-02 ${clas ? clas : ''}`}
        id={`game-card-${game.isFuture ? 'past' : 'future'}-${game.visitorTeamAbbr}_VS_${game.homeTeamAbbr}-${dateFns.format(new Date(game.startTime), 'yyyy-MMMM-dd')}`}
        style={{ height: `${height}px`, padding: `${vertical}px 2px` }}
      >
        <Badge
          past={noHover ? false : dateFns.isPast(new Date(game.startTime))}
          tooltipData={tooltipData}
          margin={margin}
        >
          {left}
          {right}
        </Badge>
      </div>
    </Link>
  );
};

export default GameBadge;
